export class RmLevelIdRequset{
    levelId?:number;
    
    constructor(levelId:number){
    this.levelId = levelId;
    }
} 
